import { Component, OnInit, Inject } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-change-statusReal',
  templateUrl: './change-status-real.component.html',
  styleUrls: ['./change-status-real.component.css']
})
export class ChangeStatusRealComponent implements OnInit {

  api_error: any;
  api_success: string;
  acc_status;
  statusTo: string;
  disableConfirmbtn = false;
  changeStatus;
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private accountService: AccountService) { }

  ngOnInit() {
    this.acc_status = this.data.productionAccount;
    console.log(this.acc_status)
    if (this.acc_status === true) {
      this.statusTo = 'Test';
      this.changeStatus = 'false'
    } else {
      this.statusTo = 'Real';
      this.changeStatus = 'true'
    }
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onConfirm() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    this.accountService.changeStatusRealAccount(this.data.id,this.changeStatus)
    .subscribe(
      data => {
        this.api_success = 'Updated Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
      this.disableConfirmbtn = false;
      this.api_error = error.error;
      }
    );

  }
}
